module.exports = {

  title: '图像管理平台',

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: false,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: true,

  tagsView: true
}



// WEBPACK FOOTER //
// ./src/settings.js